import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {IBaseResponse, WebService} from '../../services';
import {mergeAndAdd} from '..';
import {IRecentItem} from './interfaces/IRecentItem';

export interface IRecentItemStoreState {
	recentItems: IRecentItem[];
}

@Module({name: 'recentItems', namespaced: true})
class RecentItemModule extends VuexModule implements IRecentItemStoreState {
	recentItems: IRecentItem[] = [];

	@Action
	public async fetchRecentItems() {
		const response = await WebService.authenticatedClient.get<IBaseResponse<{recentItems: IRecentItem[]}>>('recent_items');
		this.setRecentItems(response.data.data.recentItems);
	}

	@Action
	public async deleteRecentItem(recentItemId: string) {
		const response = await WebService.authenticatedClient.post<IBaseResponse<{success: boolean}>>(
			`recent_items/${recentItemId}/delete`
		);
		if(response.data.data.success) {
			this.removeRecentItem(recentItemId);
		}
		return response.data.data.success;
	}

	@Mutation
	public setRecentItems(recentItems: IRecentItem[]) {
		this.recentItems = recentItems;
	}

	@Mutation
	public addRecentItem(recentItem: IRecentItem) {
		mergeAndAdd(this.recentItems, [recentItem], ['id']);
	}

	@Mutation
	public removeRecentItem(id: string) {
		this.recentItems = this.recentItems.filter(recentItem => {
			return recentItem.id !== id;
		});
	}

	@Mutation
	public clearRecentItems() {
		this.recentItems = [];
	}
}


export {
	RecentItemModule
};
